/**
 * Unified Table Loading State Component
 * Displays skeleton rows while table data is loading
 */

import React from 'react';
import {AppText} from '../ui/Typography';

interface TableLoadingStateProps {
  rows?: number;
  columns?: number;
  message?: string;
  showMessage?: boolean;
}

export const TableLoadingState: React.FC<TableLoadingStateProps> = ({
  rows = 5,
  columns = 6,
  message = 'جاري تحميل البيانات...',
  showMessage = true
}) => {
  return (
    <div className="w-full">
      {/* Loading Message */}
      {showMessage && (
        <div className="flex items-center justify-center py-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
            <AppText className="text-sm text-gray-600">{message}</AppText>
          </div>
        </div>
      )}

      {/* Skeleton Rows */}
      <table className="w-full">
        <tbody>
          {Array.from({length: rows}).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-gray-100">
              {Array.from({length: columns}).map((_, colIndex) => (
                <td key={colIndex} className="p-4">
                  <div className="animate-pulse">
                    <div
                      className="h-4 bg-gray-200 rounded"
                      style={{width: `${60 + Math.random() * 40}%`}}
                    ></div>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableLoadingState;


